
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Card } from '../../ui';

import ApersonalesWrapper from './APersonales.style';
import Steps from '../../Steps';
import { setStepsList } from "../../../actions";

import APForm_1 from './APForm_1';
import APForm_2 from './APForm_2';
import Quotation from './Quotation';
import Login from '../../Common/Login';
import APForm_3 from './APForm_3';
import ClientData from '../../Common/Client/ClientData';
import Payment from './Payment';

class APersonales extends Component {

  constructor(props) {
    super(props);

    this.state = {
      globalSteps1: ['1. Mis datos', '2. Cotización', '3. Compra'],
      globalSteps2: ['1. Tus beneficiarios', '2. Tus datos', '3. Información de pago'],
      steps: [
        { pos: 0, global:  0, name: 'apForm_1', backButton: false },
        { pos: 1, global:  0, name: 'apForm_2' },
        { pos: 2, global:  1, name: 'quotation' },
        { pos: 3, global: -1, name: 'login' },
        { pos: 4, global:  0, name: 'apForm_3' },
        { pos: 5, global:  1, name: 'clientData' },
        { pos: 6, global:  2, name: 'payment' },
      ]
    };
  } 
  
  componentDidMount() {
    const { steps } = this.state;
    const { setStepsList } = this.props;
    setStepsList(steps);
  }

  getStepContent() {
    const { selectedStep } = this.props;
    switch (selectedStep.name) {
      case 'apForm_1':   return <APForm_1 />;
      case 'apForm_2':   return <APForm_2 />;
      case 'quotation':  return <Quotation />;
      case 'login':      return <Login />;
      case 'apForm_3':   return <APForm_3 />;
      case 'clientData': return <ClientData />;
      case 'payment':    return <Payment />;
    }
  }

  render() {
    const { globalSteps1, globalSteps2 } = this.state;
    const { selectedStep } = this.props;
    return (
      <Card className="Card--medium">
        <ApersonalesWrapper>
          <Steps globalSteps={selectedStep.pos < 4 ? globalSteps1 : globalSteps2} />
          <div >
            {this.getStepContent()}
          </div>
        </ApersonalesWrapper>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    selectedStep: state.steps.selectedStep
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setStepsList: (steps) => {
      dispatch(setStepsList(steps));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(APersonales);